import React, { Component } from "react";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, Redirect } from "react-router-dom";
import http from "../../../services/HttpService";
import Route from "../../../Routes";
import InfiniteScroll from 'react-infinite-scroller';
import "../../../../assets/scss/style/_search.scss"
import {
    Container,
    Row,
    Col,

} from 'reactstrap';

import LayoutMaster from "../../../views/layout/Master";
import { layout } from "../../../../ts-helpers/decorators";

import { FilePond, registerPlugin, create } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

import swal from "sweetalert2";
import Loading from "../../includes/Loading";
import i18next from "./HomePage";
import { Translation } from "react-i18next";
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFilePoster);

import icon_1 from "../../../../assets/img/site/SVG/Asset-30.svg";
import icon_1_active from "../../../../assets/img/site/orange/Asset-30.svg";
import icon_2 from "../../../../assets/img/site/SVG/Asset-31.svg";
import icon_2_active from "../../../../assets/img/site/orange/Asset-31.svg";
import { Router } from "react-router";
import UserProfileShorcout from "./UserProfileShorcout";

@layout(LayoutMaster)
@(connect((state) => {
    return {};
}) as any)

class UserProfile extends Component<any>{
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    filePond = null;


    state = {
        tools: [],

        loading: true,
        updated: false,

        industries: [],
        industry_value: null,

        specializations: [],
        specialization_value: [],
        spec: [],
        keyword_value: '',
        user:null,
        viewResultSearch: true,
        user_infos: [],
        toolVote: false,
        pageStart: 1,
        nextPage: true,
        all_specialization: [],
        user_saveApp: []
    };

    constructor(props: Map<any, any>) {
        super(props);
        this.filePond = React.createRef();

    }

    componentDidMount() {
        const { query } = this.props.match.params;
        this.parseData(query);


        //this.props.onRef(this);
    }

userCheck=(user)=>{
    this.setState({user})
}
    componentWillReceiveProps(nextProps: Readonly<any>, nextContext: any): void {
        const { query } = this.props.match.params;
        const query1 = nextProps.match.params.query;
        if (query !== query1) {
            this.setState({
                tools: []
            }, () => this.parseData(query1));
        }
    }


    @autobind
    parseData(query) {

        const { industry_value, specialization_value, keyword_value } = JSON.parse(query);

        this.setState({
            industry_value: industry_value,
            specialization_value: specialization_value,
            keyword_value: keyword_value,
            pageStart: 1,
            loading: true
        }, () => {
            this.getData();
            this.getIndustry();
            this.getSpecializations();
            this.handleChangeIndustry;
            this.getAllSpecializations();
        })
    }

    @autobind
    getData(page = 1) {

        const { industry_value, specialization_value, keyword_value, tools } = this.state;

        http.post(`/tools/search`, {
            industries: industry_value,
            specializations: specialization_value,
            spec: specialization_value,
            keywords: keyword_value,
            page: page,
        })
            .then(response => response.json())
            .then((data) => {
                const nextPage = !!data.length;
                this.setState({
                    loading: false,
                    updated: false,

                    tools: tools.concat(data),
                    nextPage,
                },
                    this.getUserInfo);
            });
    }

    @autobind
    getIndustry() {
        http.get(`/industries/all`)
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    industries: data,
                });
            });
    }

    @autobind
    getSpecializations() {
        const { industry_value, specialization_value } = this.state;
        industry_value !== null ?
            http.get(`/industries/getById/${industry_value.value}`)
                .then(response => response.json())
                .then((data) => {
                    this.setState({
                        specializations: data.specializations,
                        industry_value,
                        spec: specialization_value ? specialization_value[0] : null,
                        specialization_value: specialization_value,
                    });
                    console.log(specialization_value ? specialization_value[0].label : null)
                })

            : this.setState({
                industry_value: null,
                specializations: [],
                specialization_value: null,
            });
    }

    @autobind
    getAllSpecializations() {
        const { all_specialization } = this.state;
        http.get(`/specializations/all`)
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    all_specialization: data,
                });
            })
    }

    @autobind
    handleChangeIndustry(industry_value) {
        industry_value !== null ?
            http.get(`/industries/getById/${industry_value.value}`)
                .then(response => response.json())
                .then((data) => {
                    this.setState({
                        specializations: data.specializations,
                        industry_value,
                        specialization_value: null,
                    });
                })
            : this.setState({
                industry_value: null,
                specializations: [],
                specialization_value: null,
            });
    }

    @autobind
    getUserInfo() {

        const user_id = JSON.parse(localStorage.getItem('logged_user'));
        user_id &&
            http.get(`/users/getUsersVotesTool/${user_id.id}`)
                .then(response => response.json())
                .then((data) => {
                    const a = [];


                    this.setState({
                        user_infos: data
                    }, this.getUserSaveAppInfo);

                });
    }
    getUserSaveAppInfo() {

        const user_id = JSON.parse(localStorage.getItem('logged_user'));
        user_id &&
            http.get(`/users/getUsersTool/${user_id.id}`)
                .then(response => response.json())
                .then((data) => {
                    const a = [];


                    this.setState({
                        user_saveApp: data
                    });
                });
    }
    @autobind
    handleChangeSpecialization(specialization_value) {
        this.setState({
            specialization_value,
        });
    }

    @autobind
    handleChangeKeyword(event) {
        const keyword_value = event.target.value;
        this.setState({
            keyword_value,
        });
    }

    @autobind
    viewSearch(e) {
        if (this.state.viewResultSearch !== e) {
            this.setState({
                viewResultSearch: e
            });
        }
    }


    @autobind
    saveVote(id, index) {
        const user_id = JSON.parse(localStorage.getItem('logged_user'));
        const { tools, user_infos } = this.state;


        http.get(`/users/vote/${user_id.id}/${id}`)
            .then(response => response.json())
            .then((data) => {
                if (data.status == "add") {
                    tools[index].t_vote++;
                    user_infos.push(id);

                } else {
                    tools[index].t_vote--;
                    user_infos.splice(user_infos.indexOf(id), 1);
                }

                this.setState({
                    tools: tools,
                    user_infos: user_infos
                })
                console.log(user_infos)
                // this.getData()
            });
    }

    @autobind
    ind(tools) {
        const { industries, specializations, all_specialization, specialization_value, industry_value } = this.state;
        return (
            all_specialization.map((spec, j) => {
                return (
                    spec._id == tools.specializations[0] ?
                        industries.map((industrie, k) => {
                            return (
                                industrie._id == tools.industries &&
                                <button className="itemInd">
                                    <Link className="search_spec_link_style" to={Route.toUrl("search", { query: JSON.stringify({ "industry_value": { "key": k, "value": industrie._id, "label": industrie.i_name.replace(/\//g, "-") }, "specialization_value": [{ "key": j, "value": spec._id, "label": spec.s_name }], "keyword_value": "" }) })}>
                                        <span key={j}>{spec.s_name}</span>
                                    </Link>
                                </button>
                            )
                        })
                        : ''
                )
            })
        )

    }

    @autobind
    loadItems(page) {
        console.log('page!!!', page);
    }

    render() {
        const {
            updated,
            industries,
            industry_value,
            specializations,
            specialization_value,
            loading,
            tools,
            keyword_value,
            viewResultSearch,
            user_infos,
            toolVote,
            pageStart,
            nextPage
        } = this.state;


        const user = JSON.parse(localStorage.getItem('logged_user'));
        console.log(user)

        const query = JSON.stringify({
            industry_value: industry_value,
            specialization_value: specialization_value,
            keyword_value: keyword_value,
        }).replace(/\//g, "-");
        localStorage.setItem('query', query);

        const loader = <div className="loader">Loading ...</div>;

        let items = [];
        tools.map((tool, i) => {
            items.push(
                <div className={i == 0 ? "searchResult  first " : tools.length - 1 == i ? "searchResult last" : "searchResult "} key={i}>

                    <div className="searchResult_img">
                        <Link to={Route.toUrl('tool', { id: tool._id })}>
                            <img src={`${http.getDomain()}/${tool.t_image}`} />
                        </Link>
                        <Link to={Route.toUrl('tool', { id: tool._id })}>


                            <div className="searchResult_firstBlock">
                                <h1>{tool.t_title}</h1>
                                <p>
                                    {
                                        tool.t_description.length > 70 ?
                                            tool.t_description.substr(0, 70) + ' ...'
                                            :
                                            tool.t_description
                                    }
                                </p>

                                {this.ind(tool)}
                            </div>
                        </Link>
                    </div>


                    <div className="searchResult_secondBlock">
                        {
                            tool.t_featured &&
                            <span>Featured</span>
                        }
                        {
                        this.state.user  ||  user && user.role == 'user'   ?



                                <div className={
                                    this.state.user_infos.find(e => {
                                        if (e._id == tool._id || e == tool._id) {

                                            return true
                                        }
                                        else {

                                            return false
                                        }
                                    }) ? "voteCount active" : "voteCount"}


                                    onClick={() => this.saveVote(tool._id, i)}>

                                    <img src={
                                        this.state.user_infos.find(e => {
                                            if (e._id == tool._id || e == tool._id) {

                                                return true
                                            }
                                            else {

                                                return false
                                            }
                                        }) ? "/voted.png" : "/down-arrow.png"} />
                                    <div> {
                                        !tool.t_vote ?
                                            0
                                            :
                                            tool.t_vote
                                    }</div>

                                </div>
                                :
                                <div className="voteCount" >
                                    <img src="/down-arrow.png" />
                                    <div> {
                                        !tool.t_vote ?
                                            0
                                            :
                                            tool.t_vote
                                    }</div>

                                </div>

                        }

                    </div>


                </div>

            );
        });

        return (

            <div className="searchPage_container">
                {this.state.industry_value ? <h4>{this.state.industry_value.label} / {specialization_value ? specialization_value.map((e, i) => { if (i > 0) { return "," + e.label } return e.label }) : null}</h4> : null}
                <h3>Search results</h3>
                {
                    loading ? <Container><Row><Col className="text-center"><Loading isLoading={loading} icon="loadDashboardInfo" /></Col></Row></Container> :
                        <div className="searchPage_subContainer">
                            <InfiniteScroll
                                pageStart={pageStart}
                                loadMore={this.getData}
                                hasMore={nextPage}
                                loader={loader}>
                                {items}
                            </InfiniteScroll >
                            <div className="profileContainer">
                                <div className="profileBlock">
                                    {user ?
                                       <UserProfileShorcout info={this.state.user_infos} check={this.userCheck}/>
                                        :
                                        <h5>Save your favorite products and vote for them to help others make a great decision</h5>
                                    }

                                </div>
                                <div className="buttBlock">
                                    {user ? <button onClick={this.getUserInfo}>Show your profile</button> : <button>Sign up now</button>}

                                </div>
                            </div>

                        </div>

                }
            </div>
        );
    }
}

export default UserProfile;
